import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import api from '../../axios/axios'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setCartLength } from '../../redux/features/auth/userSlice';
import Swal from 'sweetalert2';
import {  SignedIn, SignedOut, useUser } from '@clerk/clerk-react';
import { Link, useNavigate } from 'react-router-dom';
const Warranty = ({cartDetails, totalPrice, selectedWarranty}) => {
    const [quantity, setQuantity] = useState(1);
    const currentUser=useSelector((state)=>state.user.currentUser)
    const productDetails = useSelector((state) => state.product.productDetails);
    const {isSignedIn}=useUser()
    const navigate=useNavigate()
   const dispatch=useDispatch()
   const cartLength = useSelector((state) => state.user?.cartLength)||0;
  // const [selectedWarranty, setSelectedWarranty] = useState(
  //   "3-Year Limited Warranty"
  // );
  // const basePrice = 116.59; 

  // const warrantyPrices = {
  //   "3-Year Limited Warranty": 0,
  //   "5-Year Limited Warranty": 4.23,
  //   "5-Year Unlimited Warranty": 10.6,
  // };

  // const calculateTotalPrice = () => {
  //   return ((basePrice + warrantyPrices[selectedWarranty]) * quantity).toFixed(
  //     2
  //   );
  // };
  // const calculateInstallment = () => {
  //   return (calculateTotalPrice() / 4).toFixed(2);
  // };

  const handleAddCart=async(id)=>{
    
    if(!isSignedIn){
      navigate('/login')
      return
    }
    if (cartDetails?.attributes?.length < 4) {
      Swal.fire({
        title: 'Insufficient Items',
        text: 'You need at least 4 attributes to add this product to the cart.',
        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#0274BD', // Customize button color
      });
    } else {
    
    try{
      const response=await api.post(`user/addToCart/${id}`,{
        userId: currentUser._id,
        cartDetails: {
          ...cartDetails,
          warranty: { name: selectedWarranty, price: 0 }
        }
      });
      dispatch(setCartLength(cartLength + 1));
      Swal.fire({
        title: 'Product Added!',
        text: 'Your product has been successfully added to the cart.',
        icon: 'success',
        confirmButtonText: 'Great!',
      });      
       
    }catch(error){  
      Swal.fire("Something went wrong")
    }
  }
  }
  return (
    <>
    <div className="flex max-w-5xl mx-auto p-2 bg-gradient-to-r from-[#4961cb] to-[#24316a]">
  {/* Pricing and Cart Section */}
  <div className="rounded-md p-2 w-full max-w-md mx-auto shadow-sm">
    <div className="flex flex-col space-y-3">
      {/* Product Name Section */}
      <div className="flex justify-between items-center">
        <span className="text-sm text-white font-medium">Product:</span>
        <h4 className="text-md text-white font-semibold truncate">
          {productDetails?.productName || "Item Name"}
        </h4>
      </div>


      {/* Warranty Section
      
      <div className="flex justify-between items-center mt-2">
        <span className="text-sm text-white font-medium">Warranty Price:</span>
        <span className="text-md text-white font-semibold">$0.00</span>
      </div> */}

      {/* Price Section */}
      <div className="flex justify-between items-center">
        <span className="text-sm text-white font-medium">Price:</span>
        <span className="text-md text-white font-semibold">
          ${cartDetails?.totalPrice || "0.00"}
        </span>
      </div>

      

      {/* Add to Cart Button */}
      <div className="flex justify-between">
      <div>
        <button
          className="bg-blue-800 text-white text-sm py-2 px-6 rounded-md font-thin hover:bg-blue-500 transition duration-150"
          onClick={() => handleAddCart(cartDetails?.productId)}
        >
          Add to Cart
        </button>
        </div>
        <div className="">
  {isSignedIn ? (
    <SignedIn>
      <Link to="/cart">
        <button
          // onClick={handleBro}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="My Cart"
          className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg shadow-lg transition duration-300 ease-in-out transform hover:scale-105"
        >
          View Cart
        </button>
      </Link>
    </SignedIn>
  ) : (
    <SignedOut>
      <Link to="/login">
        <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105">
          View Cart
        </button>
      </Link>
    </SignedOut>
  )}
</div>

      </div>
    </div>
  </div>
</div>

    <ToastContainer />
  </>
  
  )
}

export default Warranty